import React from "react";
import Footer from "./Footer";
function Download({index, bgFromIndex}) {
  return (
    <section id="download" className="download-section" style={{backgroundColor: bgFromIndex(index)}}>

      <div style={{ width:"100%", height: "90vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems:"center", gap:"20px"}}>

      <h2>Download the App</h2>
      <img className="logo"  src="/assets/full_icon_no_bg.png"></img>
      <div className="download-links" style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop:"25px"
      }}>
        <a href="https://play.google.com" target="_blank" rel="noreferrer">
          <img src="/assets/googlestore.png" alt="Google Play Store" />
        </a>
        <a
          href="https://apps.apple.com/app/master-sudoku-challenge/id6670557985"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/assets/appstore.svg" alt="App Store" />
        </a>
      </div>

      </div>
      <div style={{backgroundColo:"red", width: "100%", height: "10vh"}}>
      <Footer />
      </div>
    </section>
  );
}

export default Download;
